export const TEST_ID = 'partSelectPanelField';
